import { queryOptions } from "@tanstack/react-query"

export interface AuthUser {
  id: string
  userName: string
  email: string
  role: string
}

export async function fetchMe(): Promise<AuthUser | null> {
  // Chạy local (vite dev): server API tự khởi động lại mỗi lần sửa code (tsx watch) — lúc đó /api/auth/me trả 5xx hoặc mất kết
  // nối. Coi ngay là "chưa đăng nhập" thì hiện màn đăng nhập tới khi tải lại trang, dù đăng nhập dev vẫn bật (user 14/10: "bypass
  // local không cần đăng nhập") → thử lại tới khi server lên lại: 12 giây cũ không đủ (khởi động lại mất vài chục giây), giờ chờ
  // tối đa 2 phút. Bản chạy thật giữ y cũ (một lần).
  const tries = import.meta.env.DEV ? 80 : 1
  for (let i = 1; ; i++) {
    try {
      const res = await fetch("/api/auth/me", { credentials: "include", cache: "no-store" })
      if (res.ok) {
        const data = (await res.json()) as { user: AuthUser | null }
        return data.user ?? null
      }
      if (res.status < 500 || i >= tries) return null
    } catch (error) {
      if (i >= tries) throw error
    }
    await new Promise((resolve) => setTimeout(resolve, 1500))
  }
}

export const meQueryOptions = queryOptions({
  queryKey: ["auth", "me"],
  queryFn: fetchMe,
  staleTime: 45_000,
  gcTime: 5 * 60_000,
  retry: false,
  refetchOnWindowFocus: false,
})
